export const CATEGORY_LABELS = {
  SUPPLIES: 'Vật tư',
  UTILITIES: 'Điện nước',
  MAINTENANCE: 'Bảo trì',
  MAINTENANCE_REPAIR: 'Sửa chữa',
  SALARY: 'Lương',
  TRANSPORTATION: 'Vận chuyển',
  MARKETING: 'Marketing',
  CASH_WITHDRAWAL: 'Rút tiền mặt',
  OTHER: 'Khác',
};

// #235631 (lệnh sếp 28/08/2026): phiếu chi chỉ còn 3 trạng thái — "Đã chi" (PAID) đã bỏ,
// mọi phiếu PAID cũ đã được chuyển thành APPROVED bằng migration.
export const VOUCHER_STATUS_LABELS = {
  PENDING: 'Chờ duyệt',
  APPROVED: 'Đã duyệt',
  REJECTED: 'Từ chối',
  // #164550 — huỷ phiếu ĐÃ DUYỆT (khác Từ chối là chặn trước khi duyệt).
  CANCELLED: 'Đã huỷ',
};

export const VOUCHER_STATUS_COLORS = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'danger',
  CANCELLED: 'secondary',
};

export const PAYMENT_METHOD_LABELS = {
  CASH: 'Tiền mặt',
  BANK_TRANSFER: 'Chuyển khoản',
};

export const SHIFT_STATUS_LABELS = {
  PENDING: 'Chờ duyệt',
  APPROVED: 'Đã duyệt',
  IN_PROGRESS: 'Đang làm',
  COMPLETED: 'Hoàn tất',
  CANCELLED: 'Hủy',
};

export const SHIFT_STATUS_COLORS = {
  PENDING: 'warning',
  APPROVED: 'info',
  IN_PROGRESS: 'primary',
  COMPLETED: 'success',
  CANCELLED: 'secondary',
};
